import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmModal = ({ type, name, onClose, onConfirm }) => {
  const typeLabels = {
    service: 'service',
    property: 'propriété',
    vehicle: 'véhicule'
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-xl shadow-premium border border-border max-w-md w-full">
        <div className="p-4 md:p-6">
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-100 mx-auto mb-4">
            <Icon name="AlertTriangle" className="w-6 h-6 text-red-600" />
          </div>
          <h2 className="text-xl font-bold text-foreground text-center mb-2">
            Confirmer la suppression
          </h2>
          <p className="text-muted-foreground text-center mb-6">
            Êtes-vous sûr de vouloir supprimer {typeLabels?.[type] || 'cet élément'} <span className="font-semibold text-foreground">{name}</span> ? Cette action est irréversible.
          </p>
          <div className="flex gap-4">
            <Button variant="outline" onClick={onClose} className="flex-1">
              Annuler
            </Button>
            <Button onClick={onConfirm} className="flex-1 bg-red-600 hover:bg-red-700">
              Supprimer
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;